var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.exhibitor.company_name
    ? _c(
        "span",
        [
          _c(
            "exhibitor-row",
            {
              attrs: { exhibitor: _vm.exhibitor, listDisplay: false },
              on: {
                "favorite-changed": function ($event) {
                  return _vm.onFavoritesChanged($event)
                },
              },
            },
            [
              _c("div", {
                staticClass: "py-3",
                domProps: { innerHTML: _vm._s(_vm.exhibitor.lead.html) },
              }),
            ]
          ),
        ],
        1
      )
    : _c("div", [
        _c("h2", { staticClass: "text-center" }, [_vm._v("not found")]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }